import logo from './logo.svg';
import './App.css';
import MarketingPage from './marketing-page/MarketingPage.js';

import * as React from 'react';
import { PaletteMode, ThemeProvider, createTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import AppAppBar from './marketing-page/components/AppAppBar';
import Hero from './marketing-page/components/Hero.js';
import LogoCollection from './marketing-page/components/LogoCollection';
import Highlights from './marketing-page/components/Highlights';
import Pricing from './marketing-page/components/Pricing';
import Features from './marketing-page/components/Features';
import Testimonials from './marketing-page/components/Testimonials';
import FAQ from './marketing-page/components/FAQ';
import Footer from './marketing-page/components/Footer';
import getMPTheme from './marketing-page/theme/getMPTheme';
import TemplateFrame from './marketing-page/TemplateFrame';


function App() {
    const [mode, setMode] = React.useState('light');
    const MPTheme = createTheme(getMPTheme(mode));
    const defaultTheme = createTheme({ pallette : { mode } });

    const [demoRequested, requestDemo] = React.useState(false);

    const requestADemo = () => {
        document
            .querySelector('#demo')
            .scrollIntoView({ behavior: 'smooth', block: 'center' });

        requestDemo(() => true);
    };

    return (
        <div className="App"
            style={{
                backgroundColor : 'rgba(36, 9, 0, 90%)',
            }}
        >
            <ThemeProvider
                theme={MPTheme} //{showCustomTheme ? MPTheme : defaultTheme}
            >
                <CssBaseline enableColorScheme />
                <AppAppBar />
                <Hero requestADemo={requestADemo} />
                <Box style={{ background: '#111', color: '#eee' }}>
                    <Container
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'left',
                            pt: { xs: 14, sm: 20 },
                            pb: { xs: 8, sm: 12 },
                            textAlign: 'left',
                            fontSize: '1.3rem',
                        }}
                    >
                        <Typography variant="h1">
                            Trusted by financial institutions worldwide
                        </Typography>
                        <Typography
                            variant="caption"
                            style={{
                                fontSize: '1.3rem',
                                maxWidth: '768px',
                                paddingTop: '2rem',
                            }}
                        >
                            &quot;We've just seen tremendous success with Orange, even
                            in the first months. Orange helps bring investment returns
                            up by fifty to sixty percent of what was coming through with
                            our organic management model.&quot;
                        </Typography>
                        <Stack style={{ paddingTop: '2rem' }} direction="row">
                            <Avatar src="/vic-patil.jpg" style={{ margin: '1rem' }} />
                            <Box>
                                <Typography variant="h4">Bajaj Patil</Typography>
                                CIO, Maharashtra Investment Group
                            </Box>
                        </Stack>
                    </Container>
                </Box>
                <div
                    style={{ background: 'white' }}
                >
                    {/*<LogoCollection />*/}
                    <Features />
                    {/*<Divider />
                    <Testimonials />*/}
                    <Divider />
                    <Highlights />
                    {/*<Divider />
                    <Pricing />*/}
                    {/*<Divider />
                    <FAQ />*/}
                    <Divider />
                    <Container id="demo">
                        <Paper
                            style={{
                                margin: '3rem 0',
                                padding : '10rem',
                            }}
                        >
                            {demoRequested
                                ? (
                                    <Stack direction='column' spacing={2} useFlexGap>
                                        <Typography variant="h2">
                                            Thank you for your interest in Orange
                                        </Typography>
                                        <Typography variant="h5">
                                            Someone from our sales team will be
                                            in touch with you shortly to schedule
                                            a live demo of our product.
                                        </Typography>
                                    </Stack>
                                )
                                :
                                (
                                    <Stack direction='row' spacing={2} useFlexGap>
                                        <TextField
                                            size="large"
                                            variant="outlined"
                                            placeholder="Your email address"
                                            fullWidth
                                            inputProps={{ style : { fontSize: '1.25rem'} }}
                                            InputLabelProps={{ style : { fontSize: '1.25rem'} }}
                                        />
                                        <Button
                                            variant="outlined"
                                            size="large"
                                            sx={{
                                                minWidth: 'fit-content',
                                                fontSize: '1.25rem',
                                                backgroundColor: '#111',
                                                color: '#eee',
                                                paddingTop: 0,
                                                paddingBottom : 0,
                                            }}
                                        >
                                            Request a demo
                                        </Button>
                                    </Stack>
                                )
                            }
                        </Paper>
                    </Container>
                    {/* @todo: another Request-a-Demo email box like at the top */}
                    <Divider />
                    <Footer />
                </div>
            </ThemeProvider>
        </div>
    );
}

export default App;
